// Import api models.
import {
	AllowedEndorsementDateRange,
	EndorsementResponse,
	PossiblePeril,
} from '@app/models/api';

interface EndorsementState {
	areEndorsementPossiblePerilsLoaded: boolean;
	isEndorsementLoaded: boolean;
	endorsement?: EndorsementResponse;
	selectedBuildingGuid?: string;
	selectedMortgageeGuid?: string;
	allowedEndorsementDateRange?: AllowedEndorsementDateRange;
	endorsementPossiblePerils: PossiblePeril[];
};


const getInitialState = (): EndorsementState => {
	return {
		areEndorsementPossiblePerilsLoaded: false,
		isEndorsementLoaded: false,
		endorsement: undefined,
		selectedBuildingGuid: undefined,
		selectedMortgageeGuid: undefined,
		allowedEndorsementDateRange: undefined,
		endorsementPossiblePerils: []
	};
};

export { getInitialState, EndorsementState };